import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AiSolutionIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M22.7988 8.312L17.8437 6.1572L15.6875 1.2007C15.4492 0.653802 14.5508 0.653802 14.3125 1.2007L12.1572 6.1572L7.2007 8.312C6.9273 8.4311 6.75 8.7016 6.75 9C6.75 9.2984 6.9272 9.5688 7.2007 9.688L12.1572 11.8428L14.3125 16.7989C14.4316 17.0733 14.7012 17.2501 15 17.2501C15.2988 17.2501 15.5684 17.0733 15.6875 16.7989L17.8437 11.8428L22.7988 9.688C23.0732 9.5689 23.25 9.2984 23.25 9C23.25 8.7016 23.0732 8.4312 22.7988 8.312ZM16.9746 10.585C16.7998 10.6607 16.6611 10.7998 16.5859 10.9737L15 14.6192L13.415 10.9737C13.3388 10.7999 13.2002 10.6607 13.0263 10.585L9.3808 9L13.0263 7.415C13.2001 7.3393 13.3388 7.2002 13.415 7.0263L15 3.3803L16.5859 7.0263C16.6611 7.2001 16.7998 7.3393 16.9746 7.415L20.6191 9L16.9746 10.585Z"
        fill={color}
      />
      <path
        d="M11.7988 16.8125L8.58489 15.415L7.18789 12.2011C6.94959 11.6532 6.05019 11.6532 5.81189 12.2011L4.41489 15.415L1.20099 16.8125C0.927086 16.9316 0.749786 17.2012 0.749786 17.5C0.749786 17.7988 0.926986 18.0684 1.20099 18.1875L4.41489 19.585L5.81189 22.7989C5.93099 23.0733 6.20109 23.2501 6.49989 23.2501C6.79869 23.2501 7.06869 23.0733 7.18789 22.7989L8.58489 19.585L11.7988 18.1875C12.0727 18.0684 12.25 17.7988 12.25 17.5C12.25 17.2012 12.0728 16.9316 11.7988 16.8125ZM7.71629 18.3271C7.54199 18.4023 7.40279 18.541 7.32709 18.7158L6.49999 20.6191L5.67289 18.7158C5.59719 18.541 5.45809 18.4023 5.28369 18.3271L3.38139 17.5L5.28369 16.6729C5.45799 16.5977 5.59719 16.459 5.67289 16.2842L6.49999 14.3809L7.32709 16.2842C7.40279 16.459 7.54189 16.5977 7.71629 16.6729L9.61859 17.5L7.71629 18.3271Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

AiSolutionIcon.displayName = 'AiSolutionIcon';
